<div mat-dialog-content>
  <p>{{data.message}}</p>
</div>
<div mat-dialog-actions>
  <button mat-button [mat-dialog-close]=false cdkFocusInitial>{{data.closeLabel}}</button>
  <button *ngIf="data.requestConfirm === true" mat-button [mat-dialog-close]=true cdkFocusInitial>{{data.confirmLabel}}</button>
</div>